import { styled } from '@mui/material';
import { Form } from 'formik';

export const FormStyled = styled(Form, {
  shouldForwardProp: (prop) => prop !== 'hasMarginBottom',
})(({ theme, hasMarginBottom }) => ({
  '&.formContainer .MuiChip-root': {
    alignSelf: 'flex-end',
  },

  [theme.breakpoints.down('lg')]: {
    '& > *:nth-last-child(2)': {
      marginBottom: hasMarginBottom && '34px !important',
    },
  },
}));
